import React, { useCallback, useEffect, useRef, useState } from 'react';
import './VoterFileUpload.scss';
import { useApi } from '../../hooks';
import LoadingImg from './loading.gif';

interface FileItem {
  name: string;
  createdTime: string;
  mimeType: string;
  id: string;
}

const FilesTable: React.FC = () => {
  const { getVoterFileList, submitFileForUpload, getCurrentlyUploadingFile } =
    useApi();
  const [files, setFiles] = useState<FileItem[]>([]);
  const [currentUploadInfo, setCurrentUploadInfo] = useState<any | undefined>();
  const [polling, setPolling] = useState(false);
  const currentUploadInfoRef = useRef<any>();
  const pollingRef = useRef<any>();

  useEffect(() => {
    currentUploadInfoRef.current = currentUploadInfo; // Always holds the latest value
  }, [currentUploadInfo]);

  useEffect(() => {
    pollingRef.current = polling; // Always holds the latest value
  }, [pollingRef, polling]);

  const refreshCurrentlyUploadingFile = useCallback(async () => {
    if (polling) {
      return;
    }
    setPolling(true);
    const currentlyUploadingFileResponse = await getCurrentlyUploadingFile();
    if (currentlyUploadingFileResponse?.data?.data) {
      setCurrentUploadInfo(currentlyUploadingFileResponse?.data?.data);
    }
    setPolling(false);
  }, [getCurrentlyUploadingFile, setCurrentUploadInfo, setPolling]);

  useEffect(() => {
    const initialize = async () => {
      const voterFileListResponse = await getVoterFileList();
      if (voterFileListResponse?.data?.data) {
        setFiles(voterFileListResponse?.data?.data);
      }
      refreshCurrentlyUploadingFile();
      setInterval(() => {
        if (currentUploadInfoRef.current && !pollingRef.current) {
          refreshCurrentlyUploadingFile();
        }
      }, 3000);
    };
    initialize();
  }, []);

  const handleUpload = (file: FileItem) => {
    if (window.confirm(`Are you sure you want to upload ${file.name}?`)) {
      submitFileForUpload(file.id);
      setTimeout(() => {
        refreshCurrentlyUploadingFile();
        setInterval(() => {
          if (!pollingRef.current) {
            refreshCurrentlyUploadingFile();
          }
        }, 3000);
      }, 1000);
    }
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleString(); // You can customize the format as needed
  };

  return (
    <div className="files-table__wrapper">
      <h4>Files in Google Drive</h4>
      <table className="files-table">
        <thead>
          <tr>
            <th>File Name</th>
            <th>Date Added to Drive</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {files
            .sort(
              (a, b) =>
                new Date(b.createdTime).getTime() -
                new Date(a.createdTime).getTime(),
            )
            .map((file, index) => (
              <tr key={index}>
                <td>{file.name}</td>
                <td>{formatDate(file.createdTime)}</td>
                <td>
                  <button
                    disabled={
                      currentUploadInfo &&
                      !currentUploadInfo?.progress?.includes('100')
                        ? true
                        : false
                    }
                    onClick={() => handleUpload(file)}
                  >
                    Upload
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      <div>
        {currentUploadInfo ? (
          <div className="uploading-table">
            <header className="uploading-table__header">
              {!currentUploadInfo?.progress?.includes('100') ? (
                <>
                  <h3>!! Upload In Process !!</h3>
                  <img
                    className="uploading-table__loader"
                    src="/loading.gif"
                    alt="Loading"
                  />
                </>
              ) : (
                <h3>Upload Complete</h3>
              )}
            </header>
            <table className="uploading-table__content">
              <tbody>
                <tr>
                  <th>Processing</th>
                  <td>
                    {
                      files.find((file) => file.id === currentUploadInfo.fileId)
                        ?.name
                    }
                  </td>
                </tr>
                <tr>
                  <th>New Database Collection</th>
                  <td>{currentUploadInfo.collectionName || 'N/A'}</td>
                </tr>
                <tr>
                  <th>Progress</th>
                  <td>
                    {currentUploadInfo.progress
                      ? `${currentUploadInfo.progress}`
                      : 'Downloading file from Google Drive'}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : null}
      </div>
    </div>
  );
};

const VoterFileUpload = () => {
  return (
    <div>
      <h2>Check My Registration: Voter File Upload</h2>
      <FilesTable />
    </div>
  );
};

export default VoterFileUpload;
